delModifier